import { render, staticRenderFns } from "./newprepress.vue?vue&type=template&id=6e70d170&"
import script from "./newprepress.vue?vue&type=script&lang=js&"
export * from "./newprepress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports